import { createContext } from 'react'

import type { AvatarProps } from './props.tsx'

export const AvatarContext = createContext<Pick<AvatarProps, 'color' | 'size'>>({})
